import { type FC, type PropsWithChildren } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { theme } from './theme';
import { Router } from './router';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import './styles/globals.css';
import './styles/variables.css';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60_000,
            refetchOnWindowFocus: false,
        },
    },
});

export const Root: FC<PropsWithChildren> = () => {
    return (
        <MantineProvider theme={theme}>
            <Notifications />

            <QueryClientProvider client={queryClient}>
                <Router />
            </QueryClientProvider>
        </MantineProvider>
    );
};
